import React, { useState, useRef, useEffect } from "react";
import { FileCode, Folder } from "lucide-react";

function InlineFileInput({ type = "file", level = 0, onConfirm, onCancel }) {
    const [value, setValue] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        const frame = requestAnimationFrame(() => inputRef.current?.focus());
        return () => cancelAnimationFrame(frame);
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            if (value.trim()) {
                onConfirm(value.trim());
            } else {
                onCancel();
            }
        } else if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            onCancel();
        }
    };

    const handleBlur = () => {
        if (value.trim()) {
            onConfirm(value.trim());
        } else {
            onCancel();
        }
    };

    const Icon = type === "folder" ? Folder : FileCode;
    const iconColor = type === "folder" ? "text-blue-500" : "text-gray-500";

    return (
        <div
            className="flex items-center py-0.5 px-2"
            style={{ paddingLeft: `${level * 12 + 8}px` }}
        >
            <Icon className={`w-4 h-4 ${iconColor} mr-2 flex-shrink-0`} />
            <input
                ref={inputRef}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                className="flex-1 text-sm px-1.5 py-0.5 border border-blue-500 rounded-sm outline-none bg-white font-mono min-w-0"
                placeholder={type === "folder" ? "folder-name" : "filename.jsx"}
            />
        </div>
    );
}

export default InlineFileInput;
